import { cn } from "@/lib/utils";
import React, { FC, SVGProps } from "react";

const Earth: FC<SVGProps<SVGSVGElement>> = ({ className, ...props }) => {
  return (
    <svg
      className={cn("fill-[#0F1324]/[0.6]", className)}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M9.0013 17.3332C4.3988 17.3332 0.667969 13.6023 0.667969 8.99984C0.667969 4.39734 4.3988 0.666504 9.0013 0.666504C13.6038 0.666504 17.3346 4.39734 17.3346 8.99984C17.3346 13.6023 13.6038 17.3332 9.0013 17.3332ZM7.09297 15.389C6.27081 13.6451 5.79453 11.7583 5.69047 9.83317H2.3863C2.54846 11.1156 3.07957 12.3233 3.91511 13.3096C4.75065 14.2959 5.85465 15.0183 7.09297 15.389ZM7.35964 9.83317C7.48547 11.8657 8.0663 13.7748 9.0013 15.4598C9.96157 13.7303 10.5225 11.8077 10.643 9.83317H7.35964ZM15.6163 9.83317H12.3121C12.2081 11.7583 11.7318 13.6451 10.9096 15.389C12.148 15.0183 13.252 14.2959 14.0875 13.3096C14.923 12.3233 15.4541 11.1156 15.6163 9.83317ZM2.3863 8.1665H5.69047C5.79453 6.24133 6.27081 4.35458 7.09297 2.61067C5.85465 2.9814 4.75065 3.7038 3.91511 4.69008C3.07957 5.67637 2.54846 6.88409 2.3863 8.1665ZM7.36047 8.1665H10.6421C10.5219 6.192 9.96128 4.26945 9.0013 2.53984C8.04104 4.26938 7.4801 6.19194 7.35964 8.1665H7.36047ZM10.9096 2.61067C11.7318 4.35458 12.2081 6.24133 12.3121 8.1665H15.6163C15.4541 6.88409 14.923 5.67637 14.0875 4.69008C13.252 3.7038 12.148 2.9814 10.9096 2.61067Z" />
    </svg>
  );
};

export default Earth;
